/**
 * WelcomeHeader Component
 *
 * Feature: 011-registration-welcome
 *
 * Displays personalized greeting, BOSI tagline, and intro paragraph
 * for the welcome page shown after registration.
 */

import React from 'react';

interface WelcomeHeaderProps {
  userName: string;
}

const WelcomeHeader: React.FC<WelcomeHeaderProps> = ({ userName }) => {
  return (
    <header className="text-center mb-8 px-4">
      {/* Personalized Greeting */}
      <h1 className="text-4xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
        Welcome, {userName}! 👋
      </h1>

      {/* BOSI Tagline */}
      <p className="text-2xl text-[#C98CCC] mb-6 font-semibold" style={{ fontFamily: 'Nunito, sans-serif' }}>
        Your body knows. BOSI helps you listen.
      </p>

      {/* Intro Paragraph */}
      <p className="text-lg text-gray-700 max-w-2xl mx-auto leading-relaxed">
        Track your daily wellness and receive personalized guidance for navigating
        perimenopause and menopause with confidence.
      </p>
    </header>
  );
};

export default WelcomeHeader;
